export default {
  // 模块名称
  workOrder: {
    // 按钮类
    button: {
      add: '新增',
      batchDel: '批量删除',
      reset: '重置',
      query: '查询',
      save: '保存',
      cancel: '取消',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      commit: '发布',
      setPermission: '权限设置',
      relation: '账户关联',
      back: '返回'
    },
    // 文字标签类
    label: {
      templateName: '模板名称',
      workOrderType: '工单类型',
      fileUpload: '图片上传',
      createTime: '创建时间',
      editTable: '编辑表格',
      deleteTable: '删除表格',
      editFlow: '表单流程',
    },
    // 提示类
    placeholder: {
      templateName: '请输入模板名称',
      workOrderType: '请选择工单类型',
      fileUpload: '请上传图片'
    },
    // 消息类
    message: {
      deltips: '您确定删除该工单模板吗?',
    },
    // 标题类
    title: {
      warn: '确认',
      fields: '表格名称编辑',
      createTable: '创建表格',
      createFlow: '创建流程',
      addColumn: '添加列',
      dataColumn: '数据字段',
      column: '字段',
      create: '创建模板'
    }
  }
}